"use strict";

var _defineProperty = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = exports.Divider = exports.Menu = void 0;

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

var clsx_1 = __importDefault(require("clsx"));

var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));

var core_1 = require("@material-ui/core");

var Dashboard_1 = __importDefault(require("@material-ui/icons/Dashboard"));

var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));

var drawerWidth = 240;
var useStyles = makeStyles_1.default(function (theme) {
  return {
    root: {
      display: 'flex'
    },
    toolbar: {
      paddingRight: theme.spacing(3)
    },
    toolbarIcon: Object.assign({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 8px'
    }, theme.mixins.toolbar),
    menuButton: {
      marginRight: theme.spacing(4.5)
    },
    menuButtonHidden: {
      display: 'none'
    },
    drawerPaper: {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    drawerPaperClose: _defineProperty({
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      width: theme.spacing(7)
    }, theme.breakpoints.up('sm'), {
      width: theme.spacing(9)
    })
  };
});

exports.Menu = function (props) {
  var _props$title = props.title,
      title = _props$title === void 0 ? null : _props$title,
      list = props.list;
  var l = list.map(function (x, i) {
    return react_1.default.createElement(react_router_dom_1.Link, {
      key: i,
      to: x.link
    }, react_1.default.createElement(core_1.ListItem, {
      button: true
    }, react_1.default.createElement(core_1.ListItemIcon, null, react_1.default.createElement(x.Icon, null)), react_1.default.createElement(core_1.ListItemText, {
      primary: x.label
    })));
  });
  return react_1.default.createElement(core_1.List, null, react_1.default.createElement(core_1.ListSubheader, {
    inset: true
  }, title), l);
};

exports.Divider = core_1.Divider;

exports.Drawer = function (props) {
  var isOpen = props.isOpen,
      onClose = props.onClose,
      children = props.children;
  var classes = useStyles();
  return react_1.default.createElement(core_1.Drawer, {
    variant: "permanent",
    classes: {
      paper: clsx_1.default(classes.drawerPaper, !isOpen && classes.drawerPaperClose)
    },
    open: isOpen
  }, react_1.default.createElement("div", {
    className: classes.toolbarIcon
  }, react_1.default.createElement(IconButton_1.default, {
    onClick: function onClick() {
      return onClose();
    }
  }, react_1.default.createElement(Dashboard_1.default, null))), children);
};